<template>
    <a-modal
        v-model="visible"
        title="案例详情"
        width="800px"
        wrapClassName="case-detail-modal"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <div class="case-detail">
            <div
                v-if="detailInfo && Object.keys(detailInfo).length"
                class="document-detail-main-body"
            >
                <div id="anchorPoint" class="anchorPoint">
                    <div class="pb-20 pl-40 pr-40">
                        <div class="title">
                            <h1 v-html="detailInfo.caseTitle"></h1>
                        </div>

                        <div class="court">
                            <span>
                                {{ detailInfo.court }}
                            </span>
                            <span>
                                {{ detailInfo.caseNo }}
                            </span>
                            <span>
                                {{ detailInfo.judgementDate }}
                            </span>
                            <span>
                                {{ detailInfo.org }}
                            </span>
                            <span>
                                {{ detailInfo.theme }}
                            </span>
                            <span>
                                {{ detailInfo.effectiveDate }}
                            </span>
                        </div>

                        <slot name="tag"> </slot>

                        <div id="parent" class="hover-scroll">
                            <div
                                v-for="item in detailInfo.documentContent"
                                :id="item.type"
                                :key="item"
                                class="document-detail-text-type"
                            >
                                <div
                                    class="text-type-title document-detail-h1"
                                    v-html="item.typeText"
                                >
                                </div>

                                <div
                                    v-for="itemChild in item.child"
                                    :id="itemChild.id"
                                    :key="itemChild"
                                >
                                    <div>
                                        <div
                                            v-if="
                                                itemChild.text
                                                    .replace('【', '')
                                                    .replace('】', '') != item.typeText
                                            "
                                            :style="{
                                                fontWeight: itemChild.bold ? 'bold' : 0,
                                                textAlign: itemChild.location,
                                            }"
                                            class="paragraph"
                                        >
                                            <div class="content-text">
                                                <div style="padding: 6px">
                                                    <span v-html="itemChild.text"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="notFound" class="empty-container">
                <img class="empty-img" src="../../../static/images/empty.png" />
                <span>未找到该案例</span>
            </div>

            <div v-else-if="loading" class="loading-container">
                <a-spin size="large" />
            </div>
        </div>

        <div class="footer-container" slot="footer">
            <div class="footer-button" @click="handleCancel"> 关闭 </div>
        </div>
    </a-modal>
</template>

<script>
    import ajax from '@/api/ajax'
    import { apiListPC } from '@/api'

    export default {
        name: 'CaseDetail',
        emits: ['update:visible'],
        props: ['visible'],

        data() {
            return {
                detailInfo: {},
                loading: false,
                notFound: false,
            }
        },

        methods: {
            handleOk(e) {
                this.$emit('update:visible', false)
                setTimeout(() => {
                    this.detailInfo = {}
                    this.loading = false
                    this.notFound = false
                }, 400)
            },

            handleCancel(e) {
                this.$emit('update:visible', false)
                setTimeout(() => {
                    this.detailInfo = {}
                    this.loading = false
                    this.notFound = false
                }, 400)
            },

            open(item) {
                console.log('open item', item)
                this.detailInfo = {}
                this.loading = true
                this.notFound = false
                this.$emit('update:visible', true)
                this.getDetail(item)
            },

            getDetail(item) {
                this.loading = true
                this.notFound = false
                return ajax(apiListPC.getCaseDetail + `/${item.caseId}`, {}, 'GET')
                    .then((res) => {
                        console.log('getDetail', res)
                        if (res && res.data) {
                            const result = res.data

                            let { segments } = result

                            //给段落都打上id
                            if (segments) {
                                for (let x in segments) {
                                    segments[x].id = 'paragraph' + x
                                }

                                //去除案号段落和裁判文书特有的类型行（此处在后端已经进行了处理，但是还需看一下，涉及到列表页返回的highLightSegmentList）
                                let newBodyText = segments.filter(
                                    (arrItem) =>
                                        arrItem.typeText != null &&
                                        arrItem.typeText != '案号' &&
                                        arrItem.typeText != arrItem.text
                                )

                                // 循环组装数组对象
                                let dataInfo = {}
                                newBodyText.forEach((item, index) => {
                                    let { typeText } = item
                                    if (!dataInfo[typeText]) {
                                        dataInfo[typeText] = {
                                            typeText,
                                            child: [],
                                            type: 'type' + index,
                                        }
                                    }
                                    dataInfo[typeText].child.push(item)
                                })

                                //对象转数组
                                result.documentContent = Object.values(dataInfo)

                                this.detailInfo = result
                            } else {
                                this.notFound = true
                            }
                        } else {
                            this.notFound = true
                        }
                    })
                    .catch(() => {
                        this.notFound = true
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
        },
    }
</script>

<style lang="less" type="text/less" scoped>
    /deep/ .case-detail-modal {
        .ant-modal-body {
            padding: 0 !important;
        }
    }

    .footer-container {
        display: flex;
        justify-content: center;

        .footer-button {
            width: 100px;
            height: 35px;
            line-height: 35px;
            text-align: center;
            color: #fff;
            font-size: 14px;
            background-color: #5867dd;
            border-radius: 10px;
            cursor: pointer;
            user-select: none;
        }
    }

    .case-detail {
        max-height: 600px;
        overflow-y: auto;
        padding: 24px;

        &::-webkit-scrollbar {
            width: 7px !important;
            height: auto !important;
            background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
        }

        .empty-container {
            height: 350px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .empty-img {
                width: 240px;
                height: 160px;
                margin-bottom: 20px;
            }
        }

        .loading-container {
            height: 350px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .document-detail-main-body {
            position: relative;
            z-index: 5;
            width: 100%;
            height: 100%;
            color: #333;
            // background-color: #ffffff;
            // border-radius: 10px 10px 0 0;
            // box-shadow: 0 0 10px 0 rgba(168, 168, 168, 0.3);
            // box-sizing: border-box;

            .anchorPoint {
                width: 100%;
                padding-top: 12px;
                margin: 0 auto;
                // background: linear-gradient(180deg, #eef4fd 0%, rgba(255, 255, 255, 0) 78px);

                &::-webkit-scrollbar {
                    width: 0;
                }

                &::-webkit-scrollbar-thumb {
                    border: none;
                }
            }

            .title {
                text-align: center;

                h1 {
                    display: inline-block;
                    font-size: 22px;
                    font-weight: normal;
                    text-align: left;
                }
            }

            .court {
                margin-top: 10px;
                margin-bottom: 27px;
                font-size: 14px;
                color: #535a6c;
                text-align: center;

                span {
                    padding: 0 10px;
                }
            }

            #parent {
                position: relative;
                min-height: 400px;
                padding-top: 18px;
                overflow-x: hidden !important;
                border-top: 1px solid #d8d8d8;
            }

            .document-detail-text-type {
                margin-top: 15px;
                margin-bottom: 42px;

                .text-type-title {
                    margin-top: 20px;
                    margin-bottom: 10px;
                }

                .document-detail-h1 {
                    padding-left: 15px;
                    font-size: 18px;
                    line-height: 16px;
                    color: #1c77fe;
                    border-left: 4px #1c77fe solid;
                    padding-top: 2px;
                    padding-bottom: 2px;
                    font-weight: 500;
                }

                .paragraph {
                    margin-top: 5px;
                    font-size: 16px;
                    line-height: 2;
                    letter-spacing: 1px;
                    color: #3d3d3d;
                    text-indent: 2em;

                    :deep(mark) {
                        display: inline;
                        padding: 2.5px 0;
                        line-height: 26px;
                        background-color: #ffe2b6;
                    }

                    :deep(table) {
                        position: static !important;
                        width: 100% !important;
                        margin: 0 !important;
                        color: #666;
                        border: 1px solid #ccc !important;
                        table-layout: auto;

                        tr td {
                            width: auto !important;
                            min-width: 54px;
                            border: 1px solid #ccc !important;
                        }
                    }
                }
            }
        }
    }
</style>
